interface LinkProps {
  href: string;
  text: string;
}

const LINKS = [
  { href: '/privacy', text: 'Privacy Policy' },
  { href: '/terms-of-use', text: 'Terms of Use' },
  { href: '/careers', text: 'Careers' },
  { href: '/accessibility', text: 'Accessibility' },
  { href: 'https://www.nerdy.com/', text: 'a Nerdy company' },
];

function FooterBottomLineLinks({ links = LINKS }: { links?: LinkProps[] }) {
  return (
    <>
      {links.map(({ href, text }) => (
        <a
          className="hover:text-link whitespace-nowrap p-2 block dark:hover:text-white dark:hover:underline"
          href={href}
          key={href}
          rel="noopener noreferrer"
          target="_blank"
        >
          {text}
        </a>
      ))}
    </>
  );
}

export default FooterBottomLineLinks;
